export const FEATURES = [
  'Go faster with Warp Speed',
  'Hibernate to pause and pay less',
  'Secure self-management with biometrics',
];
